import invariant from 'tiny-invariant'
import { isProduction } from 'utils/env'

// https://developers.openai.com/ads/measurement-pixel
export enum OpenAiEventName {
  REGISTRATION_COMPLETED = 'registration_completed',
  TRIAL_STARTED = 'trial_started',
}

export const OpenAiPlanId = {
  STUDIO_AI_FREE_TRIAL: 'studio_ai_free_trial',
  ALL_ACCESS_FREE_TRIAL: 'all_access_free_trial',
} as const

export type OpenAiPlanId = (typeof OpenAiPlanId)[keyof typeof OpenAiPlanId]

export type OpenAiEventOptions =
  | { type: 'customer_action'; amount?: number; currency?: string }
  | { type: 'plan_enrollment'; plan_id: OpenAiPlanId }

export type OpenAiMeasureFunction = (
  measure: 'measure',
  name: OpenAiEventName,
  options: OpenAiEventOptions,
) => void

declare global {
  interface Window {
    oaiq?: OpenAiMeasureFunction
  }
}

export const openAiPixelId =
  process.env.NEXT_PUBLIC_OPENAI_PIXEL_ID || process.env.VITE_OPENAI_PIXEL_ID

invariant(
  openAiPixelId,
  'NEXT_PUBLIC_OPENAI_PIXEL_ID or VITE_OPENAI_PIXEL_ID must be set inside OpenAiPixel',
)

export const scriptUrl = 'https://bzrcdn.openai.com/sdk/oaiq.min.js'

export const initScript = `!function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments)};q.q=[];w.oaiq=q;var js=d.createElement(s);js.async=true;js.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(js,f)}(window,document,"script","${scriptUrl}");oaiq("init",{pixelId:"${openAiPixelId}"});`

function measure(name: OpenAiEventName, options: OpenAiEventOptions) {
  if (!isProduction || typeof window.oaiq !== 'function') {
    return
  }

  window.oaiq('measure', name, options)
}

export function trackOpenAiRegistration() {
  measure(OpenAiEventName.REGISTRATION_COMPLETED, { type: 'customer_action' })
}

export function trackOpenAiTrialStarted(planId: OpenAiPlanId) {
  measure(OpenAiEventName.TRIAL_STARTED, { type: 'plan_enrollment', plan_id: planId })
}
